<template>
    <vSelect v-model="internalValue"
        :disabled="disabled"
        :options="options"
        @search="onSearch" >
        <template #no-options="{ search, searching, loading }">
            <template v-if="!search">
                Ricerca digitando le prime lettere.
            </template>
            <template v-else>
                Nessun risultato trovato, prova con una nuova ricerca.
            </template>
        </template>
    </vSelect>
</template>
<script>

import vSelect from 'vue-select'
import axiosService from "@/service/AxiosService";

export default {
    components: {
        vSelect
    },
    props: {
        value: [Array, Object, String],
        disabled: {
            type: Boolean,
            default: false
        },
        namespace: String,
        returnOnlyLabel: Boolean,
        returnOnlyDictionaryId: {
            type: Boolean,
            default: false
        },
        url: {
            type: String,
            default: '/api/v1/bado/dictionary/'
        }
    },
    data() {
        return {
            options: []
        }
    },
    computed: {
        internalValue: {
            get() {
                return this.value
            },
            set(value) {
                if (this.returnOnlyLabel) {
                    this.$emit('input', value.label)    
                    return
                } else if (this.returnOnlyDictionaryId) {
                    this.$emit('input', value.dictionaryId)    
                    return
                }

                this.$emit('input', value)
            }
        }
    },
    methods: {
        onSearch(search, loading) {
            if (!search) {
                this.options = []
                return
            }

            loading(true)

            axiosService.axios.get(this.url + "?q=" + search)
                .then((response) => {
                    this.options = response.data
                    loading(false)
                })
        }
    }
}
</script>